<template>
  <!-- 页面  -->
  <div class="forgot_pwd_page">
    <img class="login_logo" :src="loginImg" alt="">
    <div class="forgot_info">
      <div class="forgot_info_title">账号安全</div>
      <div class="forgot_info_box">
        <div class="forgot_pwd_name">{{ type==3?'找回密码':'修改密码' }}</div>
        <div v-if="type === 2" class="forgot_pwd_tip">请输入数字、字母组合,长度至少8位</div>
        <el-form
          v-if="type == 1"
          ref="forgot"
          onsubmit="return false;"
          :model="forgot"
          :rules="forgotRulesOne"
          class="login-form"
          label-position="left"
        >
          <el-form-item prop="phone">
            <span class="svg-container">
              <svg-icon icon-class="user" />
            </span>
            <el-input
              ref="phone"
              v-model="forgot.phone"
              class="elInput"
              :placeholder="$t('login.phone')"
              name="phone"
              type="text"
              tabindex="3"
              autocomplete="on"
              clearable
            />
          </el-form-item>
          <Verify
            v-if="verifyShow"
            :bar-size="{ width: '302px', height: '40px' }"
            :v-offset="5"
            :type="3"
            @success="alert('success')"
            @error="alert('error')"
          />
          <el-form-item
            prop="verifyCode"
            :rules="[
              { required: true, message: '请输入验证码', trigger: 'blur' },
            ]"
          >
            <div class="code_box">
              <div class="grid-content bg-purple">
                <span class="svg-container">
                  <svg-icon icon-class="Moblie" />
                </span>
                <el-input
                  v-model="forgot.verifyCode"
                  class="elInput"
                  maxlength="20"
                  :placeholder="$t('login.verifyCode')"
                  type="text"
                  clearable
                />
              </div>
              <div
                class="grid-content bg-purple-light"
                :class="{
                  'on_bg-purple-light': !logindisbled && countdown <= 0,
                }"
              >
                <span
                  v-show="countdown <= 0"
                  style="padding-right: 5px"
                  @click="getCode"
                >获取验证码</span>
                <span
                  v-show="countdown"
                  class="count"
                >{{ countdown }} s重新发送</span>
              </div>
            </div>
          </el-form-item>
          <el-button
            id="automaticLogon"
            :disabled="logindisbled"
            :loading="loading"
            type="primary"
            :class="{ on_button: !logindisbled }"
            style="width: 100%"
            @click.native.prevent="nextStep"
          >
            下一步
          </el-button>
        </el-form>
        <el-form
          v-if="type == 2"
          ref="forgot"
          onsubmit="return false;"
          :model="forgot"
          :rules="forgotRulesTwo"
          class="login-form"
          label-position="left"
        >
          <el-form-item prop="password">
            <span class="svg-container">
              <svg-icon icon-class="password" />
            </span>
            <el-input
              ref="password"
              v-model="forgot.password"
              class="elInput"
              placeholder="设置密码"
              name="password"
              type="password"
              tabindex="3"
              autocomplete="on"
              maxlength="20"
              clearable
            />
          </el-form-item>
          <el-form-item prop="confirmPass">
            <span class="svg-container">
              <svg-icon icon-class="password" />
            </span>
            <el-input
              ref="confirmPass"
              v-model="forgot.confirmPass"
              class="elInput"
              placeholder="确认密码"
              name="confirmPass"
              type="password"
              tabindex="3"
              autocomplete="on"
              maxlength="20"
              clearable
            />
          </el-form-item>
          <el-button
            id="automaticLogon"
            :disabled="onNextTo"
            :loading="loading"
            type="primary"
            :class="{ on_button: !logindisbled }"
            style="width: 100%"
            @click.native.prevent="nextStepTwo"
          >
            下一步
          </el-button>
          <!-- <div class="next_step"></div> -->
        </el-form>

        <div v-if="type == 3" class="success_info">
          <div v-if="type == 3" class="success_warn">
            您已成功设置密码，请使用新密码登录
          </div>
          <el-button
            v-if="type == 3"
            type="primary"
            :class="{ on_button: !logindisbled }"
            style="width: 100%"
            @click.native.prevent="goLogin"
          >
            马上登录
          </el-button>
        </div>

        <div v-if="type == 1" class="go_login">
          已有账号，
          <span class="login_page" @click="goLogin">马上登录</span>
        </div>
        <div v-if="type == 2" class="go_login">
          <span class="login_Return" @click="goReturn">返回上一步</span>
        </div>
      </div>
    </div>
    <div class="filing">
      【鲁公网安备 *****号】  网站备案/许可证号:【鲁ICP备2022004558号-1】
      Copyright 2024 瑞源控股集团版权所有
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Verify from "vue2-verify";

import { sendVerificationCode, forgetPass } from "@/api/user";
export default {
  // 组件引入
  components: { Verify },
  //过滤器
  filters: {},
  data() {
    const validateVerifyPhone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    const validateVerifyCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    const validateVerifyPassword = (rule, value, callback) => {
      const pwdReg = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$/;
      if (value == "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error("密码长度8-20位"));
      } else if (!pwdReg.test(value)) {
        callback(new Error("请输入数字、字母组合"));
      } else {
        callback();
      }
    };
    const validateVerifyConfirmPass = (rule, value, callback) => {
      const pwdReg = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$/;
      if (value == "") {
        callback(new Error("请确认密码"));
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error("密码长度8-20位"));
      } else if (!pwdReg.test(value)) {
        callback(new Error("请输入数字、字母组合"));
      } else if (value !== this.forgot.password) {
        callback(new Error("两次密码不一样"));
      } else {
        callback();
      }
    };

    return {
      loginImg: "",
      verifyShow: true,
      logindisbled: true,
      loading: false,
      type: 1,

      countdown: 0,

      forgot: {
        phone: "",
        verifyCode: "",
        userType: "SHIPMENT",
        judge: "0",
        password: "",
        confirmPass: "",
      },

      forgotRulesOne: {
        phone: [
          { required: true, trigger: "blur", validator: validateVerifyPhone },
        ],
        verifyCode: [
          { required: true, trigger: "blur", validator: validateVerifyCode },
        ],
      },
      forgotRulesTwo: {
        password: [
          {
            required: true,
            trigger: "blur",
            validator: validateVerifyPassword,
          },
        ],
        confirmPass: [
          {
            required: true,
            trigger: "blur",
            validator: validateVerifyConfirmPass,
          },
        ],
      },
    };
  },
  // 计算属性
  computed: {
    onNextTo() {
      if (this.forgot && this.forgot.password && this.forgot.confirmPass) {
        return false;
      } else {
        return true;
      }
    },
  },
  // 监听器
  watch: {},
  //生命周期 创建后
  created() {
    request({
      url: "/ntocc-basic-api/partyGroup/getDefault",
      method: "get",
    }).then((response) => {
      this.loginImg = response.data.loginLogoUrl;
    });
  },
  // 挂载后
  mounted() {

    this.getPartyGroup();
  },
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {

    getPartyGroup() {
      request({
        url: "/ntocc-basic-api/partyGroup/list",
        method: "get",
      }).then((response) => {
        // 默认选中第一个
        this.forgot.branchCode = response.data[0].code;
      });
    },
    nextStepTwo() {
      const pwdReg = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$/;
      if (!this.forgot.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.forgot.password.length < 8 || this.forgot.password.length > 20) {
        this.$message.error("密码长度8-20位");
        return;
      }
      if (!pwdReg.test(this.forgot.password)) {
        this.$message.error("请输入数字、字母组合");
        return;
      }
      if (!this.forgot.confirmPass) {
        this.$message.error("请确认密码");
        return;
      }
      if (this.forgot.confirmPass.length < 8 || this.forgot.confirmPass.length > 20) {
        this.$message.error("密码长度8-20位");
        return;
      }
      if (!pwdReg.test(this.forgot.confirmPass)) {
        this.$message.error("请输入数字、字母组合");
        return;
      }
      if (this.forgot.password != this.forgot.confirmPass) {
        this.$message.error("两次密码输入不一致");
        return;
      } else {
        this.forgot.newPwd = this.forgot.password;
        // this.$delete(this.forgot, 'password');
        // this.$delete(this.forgot, 'confirmPass');
      }
      let params = {
        phone: this.forgot.phone,
        verifyCode: this.forgot.verifyCode,
        userType: this.forgot.userType,
        judge: this.forgot.judge,
        newPwd: this.forgot.newPwd,
        branchCode: this.forgot.branchCode
      };
      console.log(params);
      forgetPass(params).then((response) => {
        console.log("忘记密码", response);
        this.type = 3;
      });
    },
    nextStep() {
      if (!this.forgot.phone) {
        this.$message.error("请先输入账号");
        return;
      }
      if (!this.forgot.verifyCode) {
        this.$message.error("请填写验证码");
        return;
      }
      this.type = 2;
    },
    goLogin() {
      this.$router.push({
        path: "/",
      });
    },
    goReturn() {
      this.type = 1;
    },
    alert(text) {
      if ("success" == text) {
        this.logindisbled = false;
      } else if ("error" == text) {
        this.logindisbled = true;
      }
    },
    getCode() {
      if (this.logindisbled) return;
      let phone = this.forgot.phone;
      if (!phone) {
        this.$message.error("请先输入账号");
        return false;
      } else {
        if (phone) {
          console.log("获取验证码", this.logindisbled);
          sendVerificationCode({
            phone: phone,
            partyGroupCode: "67a375220847460c14qingdaominlian",
          }).then((response) => {
            console.log("获取验证码", response);
          });
          this.countdown = 60;
          let timeCountdown = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(timeCountdown);
            }
          }, 1000);
          // this.verificationFlag = true;
          // this.imgurl =
          //   this.BASE_API_URL +
          //   "ntocc-tps-api/sms/getVerificationCodeImage?phone=" +
          //   phone +
          //   "&imageWith=300&imageHeigth=100&t=" +
          //   new Date().getTime();
          // this.$refs.verificationRef.getVerificationCodeImage(this.imgurl);
        } else {
          this.$message.error("无有效手机号，无法发送验证码");
          return false;
        }
      }
    },
  },
};
</script>

<style  lang="scss">
$bg: #e7f0fe;
$light_gray: #000;
$cursor: #000;
$dark_gray: #889aa4;
.forgot_pwd_tip{
  font-size: 12px;
  color: #999999;
  margin-bottom: 20px;
}
.forgot_pwd_page {
  width: 100%;
  height: 100%;
  background-color: #e7f0fe;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .login_logo {
    position: absolute;
    top: 25px;
    left: 50px;
    height: 28px;
  }
  .forgot_info {
    width: 672px;
    height: 490px;
    background: #f9fbfe;
    border-radius: 0px 0px 0px 0px;
    .forgot_info_title {
      width: 672px;
      height: 54px;
      background: linear-gradient(188deg, #61a1f9 0%, #3d82ee 100%);
      border-radius: 6px 6px 6px 6px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
    }
    .forgot_info_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .verify-bar-area {
        width: 305px !important;
        background: #ededed;
        margin-bottom: 1.56vw;
      }
      .verify-btn {
        display: none;
      }
      .verify-move-block {
        border-radius: 5px 0 0 5px;
        left: 0px;
      }
      .verify-bar-area .verify-left-bar {
        border-radius: 5px;
        left: 0px;
      }
      .forgot_pwd_name {
        margin-top: 40px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
      }

      .login-form {
        position: relative;
        width: 312px;
        // max-width: 100%;
        // padding: 160px 35px 0;
        margin: 0 auto;
        overflow: hidden;
        .svg-container {
          padding: 6px 5px 6px 15px;
          font-size: 16px;
          color: $dark_gray;
          vertical-align: middle;
          width: 30px;
          display: inline-block;
        }
        .elInput {
          display: inline-block;
          height: 47px;
          width: 80%;
          background: #fff;

          input {
            background: #fff;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            padding: 12px 5px 12px 15px;
            color: $light_gray;
            height: 47px;
            caret-color: $cursor;
            &:-webkit-autofill {
              box-shadow: 0 0 0px 1000px $bg inset !important;
              -webkit-text-fill-color: $cursor !important;
            }
            &:-webkit-autofill,
            textarea:-webkit-autofill,
            select:-webkit-autofill {
              -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
              background-color: transparent;
              background-image: none;
              transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
            }
          }
        }

        .el-form-item {
          border: 1px solid rgba(255, 255, 255, 0.1);
          // background: rgba(0, 0, 0, 0.1);
          background: #fff;
          border-radius: 5px;
          color: #000000;
          margin-bottom: 30px;
          position: relative;

          .forget_pwd {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 11px;
            color: #4186ef;
            line-height: 13px;
            position: absolute;
            bottom: -20px;
            right: 0;
            cursor: pointer;

            &:hover {
              opacity: 0.8;
            }
          }
          .error_pwd {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 11px;
            color: #ef4141;
            line-height: 13px;
            position: absolute;
            bottom: -20px;
            left: 0;
          }
        }

        .code_box {
          display: flex;
          align-items: center;
          .bg-purple-light {
            width: 84px;
            height: 26px;
            background: #aaaaaa;
            border-radius: 40px 40px 40px 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: rgba(255, 255, 255, 0.9);
              line-height: 18px;
            }
          }
          .on_bg-purple-light {
            background: linear-gradient(90deg, #4283f4 0%, #61a2f9 100%);
            cursor: pointer;
          }
        }
        .on_button {
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .success_info {
        width: 312px;
        height: 244px;
        .success_warn {
          height: 196px;
          width: 312px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .user_no {
        margin-top: 28px;
        width: 312px;
        height: 48px;
        background: #ffffff;
        border-radius: 6px 6px 6px 6px;
      }
      .scroll_bar {
        margin-top: 20px;
        width: 312px;
        height: 48px;
        background: #ffffff;
        border-radius: 6px 6px 6px 6px;
      }
      .phone_code {
        margin-top: 20px;
        width: 312px;
        height: 48px;
        background: #ffffff;
        border-radius: 6px 6px 6px 6px;
      }
      .next_step {
        margin-top: 20px;
        width: 312px;
        height: 48px;
        background: linear-gradient(188deg, #61a1f9 0%, #3d82ee 100%);
        border-radius: 6px 6px 6px 6px;
      }
      .go_login {
        margin-top: 30px;
        width: 137px;
        height: 28px;
        background: #e8edf4;
        border-radius: 14px 14px 14px 14px;
        font-size: 12px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        .login_page {
          color: #4186ef;
          cursor: pointer;
        }
        .login_Return {
          color: #a2a2a2;
          cursor: pointer;
        }
      }
    }
  }
  .filing {
    margin-top: 40px;
    font-size: 14px;
    color: #8b929c;
  }
}
</style>
